import React from 'react';
import { Brain, Rocket, Zap, Cpu } from 'lucide-react';

const OurSolutions = () => {
  const solutions = [
    {
      icon: Brain,
      title: 'AI Destekli SEO Mimarisi',
      description: 'Yapay zeka ve veri analitiği ile arama motoru görünürlüğünü maksimize eden sistemler.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: Rocket,
      title: 'Dönüşüm Odaklı Landing Sistemleri',
      description: 'Kullanıcı davranışı analiziyle optimize edilmiş, yüksek dönüşüm oranına sahip sayfalar.',
      color: 'from-cyan-500 to-blue-500'
    },
    {
      icon: Zap,
      title: 'Performans & Growth Altyapıları',
      description: 'Google Ads, Meta Ads ve organik büyümeyi tek platformda yöneten entegre sistemler.',
      color: 'from-orange-500 to-red-500'
    },
    {
      icon: Cpu,
      title: 'AI & Otomasyon Entegrasyonları',
      description: 'İçerik üretiminden müşteri yönetimine kadar akıllı otomasyon çözümleri.',
      color: 'from-emerald-500 to-teal-500'
    }
  ];

  return (
    <section className="py-20 bg-slate-950 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute w-[600px] h-[600px] bg-teal-500/10 rounded-full blur-3xl bottom-0 right-1/4 animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Ürettiğimiz Çözümler
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Marka satmıyoruz, yetenek satıyoruz.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="group bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-500 hover:transform hover:-translate-y-2"
              style={{
                animation: 'fade-in-up 0.8s ease-out both',
                animationDelay: `${index * 0.1}s`
              }}
            >
              {/* Icon */}
              <div className="relative w-16 h-16 mb-6">
                <div className={`absolute inset-0 bg-gradient-to-br ${solution.color} rounded-xl flex items-center justify-center transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110`}>
                  <solution.icon className="w-8 h-8 text-white transition-transform duration-500 group-hover:rotate-[-12deg]" />
                </div>
                <div className="absolute inset-0 bg-cyan-500/50 rounded-xl blur-xl opacity-0 group-hover:opacity-70 transition-opacity duration-500"></div>
              </div>

              <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors">
                {solution.title}
              </h3>

              <p className="text-gray-400 leading-relaxed">
                {solution.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-500 italic">
            Bazı projeler müşteri gizliliği nedeniyle paylaşılmamaktadır.<br />
            Burada yaklaşım ve yetkinlik örnekleri yer alır.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurSolutions;
